import styled from "styled-components";
import { darken, transparentize } from "polished";

export const Container = styled.div`
  width: 100%;
  // height: 100vh;
  max-width: 1080px;
  margin-top: 7.5rem;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h3 {
    margin-bottom: 3rem;

    color: #495156;
    text-align: center;
    font-size: 2.25rem;
    font-style: normal;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 1.8px;
  }

  span {
    font-weight: 400;
  }
`;

export const Quiz = styled.div`
  width: 100%;

  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;

  margin-top: 2rem;
  margin-bottom: 2rem;
  margin-left: 10px;
`;

interface QuizBoxProps {
  hasAdhession: boolean;
}

export const QuizBox = styled.button<QuizBoxProps>`
  width: 205px;
  height: 195px;
  /* border: 1px solid #d7d7d7; */
  border-radius: 6px;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background-color: ${(props) => (props.hasAdhession ? "#9FEFEF" : "#FFF")};
  color: ${(props) => (props.hasAdhession ? "#43474A" : "#000")};

  &:disabled {
    background-color: ${(props) =>
      props.hasAdhession ? "#9FEFEF" : "transparent"};
  }

  img {
    margin-bottom: 16px;
  }

  span {
    display: inline-block;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
  }
`;


export const Navigation = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-top: 5rem;
  margin-bottom: 2rem;
  margin-left: 20px;

  button {
    height: 45px;
    padding: 0 32px;
  }
`;
